export const CUSTOMER_ADD_REQUEST = "CUSTOMER_ADD_REQUEST";
export const CUSTOMER_ADD_SUCCESS = "CUSTOMER_ADD_SUCCESS";
export const CUSTOMER_ADD_FAILURE = "CUSTOMER_ADD_FAILURE";

export const CUSTOMER_EDIT_REQUEST = "CUSTOMER_EDIT_REQUEST";
export const CUSTOMER_EDIT_SUCCESS = "CUSTOMER_EDIT_SUCCESS";
export const CUSTOMER_EDIT_FAILURE = "CUSTOMER_EDIT_FAILURE";

export const CUSTOMER_VIEW_REQUEST = "CUSTOMER_VIEW_REQUEST";
export const CUSTOMER_VIEW_SUCCESS = "CUSTOMER_VIEW_SUCCESS";
export const CUSTOMER_VIEW_FAILURE = "CUSTOMER_VIEW_FAILURE";

export const CUSTOMER_VIEW_ALL_REQUEST = "CUSTOMER_VIEW_ALL_REQUEST";
export const CUSTOMER_VIEW_ALL_SUCCESS = "CUSTOMER_VIEW_ALL_SUCCESS";
export const CUSTOMER_VIEW_ALL_FAILURE = "CUSTOMER_VIEW_ALL_FAILURE";

export const CUSTOMER_SEARCH_REQUEST = "CUSTOMER_SEARCH_REQUEST";
export const CUSTOMER_SEARCH_SUCCESS = "CUSTOMER_SEARCH_SUCCESS";
export const CUSTOMER_SEARCH_FAILURE = "CUSTOMER_SEARCH_FAILURE";

export const CUSTOMER_DELETE_REQUEST = "CUSTOMER_DELETE_REQUEST";
export const CUSTOMER_DELETE_SUCCESS = "CUSTOMER_DELETE_SUCCESS";
export const CUSTOMER_DELETE_FAILURE = "CUSTOMER_DELETE_FAILURE";

export const CUSTOMER_RESET_STATE = "CUSTOMER_RESET_STATE";
